import {useMutation} from '@tanstack/react-query';

import type {PostCheckoutPaymentParams} from 'domain/usecases';

import {postCheckoutPayment} from '../../services/postCheckoutPayment';

export const usePostCheckoutPaymentMutation = () =>
	useMutation({
		mutationFn: (params: Omit<PostCheckoutPaymentParams, 'signal'>) =>
			postCheckoutPayment(params),
		retry: 0,
	});
